import { useContext } from 'react'
import { BookingContext } from '@/contexts/booking-context'

export function useBooking() {
  const ctx = useContext(BookingContext)
  if (!ctx) {
    throw new Error('useBooking must be used within BookingProvider')
  }
  return ctx
}
